export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data) {
      checkData(data, widgetName);
    },

    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [''],
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'Learn More',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}

function checkData(data, widgetName) {
  const widgetCount = data.items.length;
  if (widgetCount == 0) {
    $(`#${widgetName}`).remove();
    $('.tier-five').addClass('no-seo-loaded');
  } else {
    $(`#${widgetName}`).show();
    createSeo(data, widgetName);
  }
}

function createSeo(data, widgetName) {
  const { Title } = data.items[0];
  $(`#${widgetName}`).find('.card-widget-title')
    .replaceWith(`<h1 class="card-widget-title" aria-label="${Title}">         
        ${Title}
      </h1>`);
  $(`#${widgetName}`)
    .find('.buttonwrap .moreButton')
    .addClass('button')
    .removeClass('moreButton')
    .removeAttr('target');
}
